import { Invoice, InvoiceResponse } from '../schema'
import { ErpAddress, ErpAddressCreate } from '../types'

export const InvoiceAddressTransform = {
  fromErp: (data: ErpAddress): InvoiceResponse => {
    return {
      id: data.id,
      city: data.city,
      country_code: data.country_code,
      email: data.email || '',
      mobile: data.mobile || '',
      firstName: data.first_name || '',
      lastName: data.last_name || '',
      street: data.street,
      street2: data.street2 || '',
      zip: data.zip,
      vatId: data.vat,
      birth_date: data.date || data.birth_date || null,
      type: 'invoice',
    } satisfies InvoiceResponse
  },
  toErpCreate: ({
    vatId,
    customer_id,
    ...invoice
  }: Invoice & { customer_id: number }): ErpAddressCreate => {
    return {
      customer_id,
      first_name: invoice.firstName,
      last_name: invoice.lastName || '',
      country_code: invoice.country_code,
      date: invoice.birth_date || null,
      street: invoice.street,
      street2: invoice.street2 || '',
      zip: invoice.zip,
      city: invoice.city,
      type: invoice.type,
      mobile: invoice.mobile || '',
      email: invoice.email || '',
      vat: vatId,
    } satisfies ErpAddressCreate
  },
  toErpPartial: ({ vatId, ...invoice }: Partial<Invoice>) => {
    return {
      first_name: invoice.firstName,
      last_name: invoice.lastName || '',
      country_code: invoice.country_code,
      date: invoice.birth_date || null,
      street: invoice.street || '',
      street2: invoice.street2 || '',
      zip: invoice.zip,
      city: invoice.city,
      type: invoice.type,
      mobile: invoice.mobile || '',
      email: invoice.email || '',
      vat: vatId,
    } satisfies Partial<ErpAddressCreate>
  },
}
